import React, { useState, useEffect } from 'react';
import '../styles/Requests.css';
import { getRequests, respondToRequest } from '../api/graph';

// Incoming trust requests. The receiver answers "Yes, ConnectMi" or "Don't, ConnectMi".
// The requester is never told either way — that copy is shown explicitly.
function Requests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    setError('');
    try {
      const data = await getRequests();
      setRequests(data.requests || []);
    } catch (err) {
      setError(err.message || 'Could not load requests');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const answer = async (requesterId, choice) => {
    setBusyId(requesterId);
    setError('');
    try {
      await respondToRequest(requesterId, choice);
      setRequests((prev) => prev.filter((r) => r.requesterId !== requesterId));
    } catch (err) {
      setError(err.message || 'Could not record your answer');
    } finally {
      setBusyId(null);
    }
  };

  if (loading) return <div className="requests-empty">Loading requests…</div>;

  return (
    <div className="requests-container">
      <div className="requests-head">
        <h3>Trust requests</h3>
        <p className="requests-sub">Your answers are private. Nobody is told when you say no.</p>
      </div>

      {error && <div className="error-message">{error}</div>}

      {requests.length === 0 ? (
        <div className="requests-empty">No requests waiting on you right now.</div>
      ) : (
        <div className="requests-list">
          {requests.map((r) => (
            <article key={r.id} className="request-card">
              <div className="request-who">
                <div className={`req-avatar ${r.relationshipType === 'personal' ? 'personal' : 'work'}`}>
                  {(r.name || r.email || '?')[0].toUpperCase()}
                </div>
                <div>
                  <div className="req-name">{r.name || r.email}</div>
                  <div className="req-meta">
                    Wants to add you as{' '}
                    <strong className={r.relationshipType === 'personal' ? 'tag-personal' : 'tag-work'}>
                      {r.relationshipType === 'personal' ? 'Personal' : 'Work'}
                    </strong>
                  </div>
                </div>
              </div>

              <div className="request-actions">
                <button
                  className="btn-yes"
                  disabled={busyId === r.requesterId}
                  onClick={() => answer(r.requesterId, 'yes')}
                >
                  Yes, ConnectMi
                </button>
                <button
                  className="btn-dont"
                  disabled={busyId === r.requesterId}
                  onClick={() => answer(r.requesterId, 'dont')}
                >
                  Don't, ConnectMi
                </button>
              </div>

              <div className="request-note">
                {(r.name || 'They')} won't be told either way.
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}

export default Requests;
